export default function ({ redirect, $auth, route }) {
  if ($auth.loggedIn && [1, 2].includes($auth.user.role)) {
      return redirect({
          path: "/base",
      })
  }
}
